import { Grid, Button, CircularProgress, Snackbar, Alert } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { db, storage } from "../../../firebase/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const EditarImagenDashboard = () => {
    const { id } = useParams();
    const [imagen, setImagen] = useState(null);
    const [existingImageUrl, setExistingImageUrl] = useState("");
    const [existingImagePath, setExistingImagePath] = useState("");
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    useEffect(() => {
        const fetchImagen = async () => {
            try {
                const docRef = doc(db, "misterio", id);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setExistingImageUrl(data.url || "");

                    if (data.url) {
                        const segments = data.url.split("%2F");
                        const fileName = segments[segments.length - 1].split("?")[0];
                        setExistingImagePath(`misterio/${decodeURIComponent(fileName)}`);
                    }
                }
            } catch (error) {
                console.error("Error al cargar la imagen:", error);
            }
        };
        fetchImagen();
    }, [id]);

    const handleImageChange = (e) => {
        if (e.target.files[0]) setImagen(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!imagen) {
            alert("Selecciona una imagen antes de subir.");
            return;
        }

        setLoading(true);
        try {
            // Borrar imagen anterior
            if (existingImagePath) {
                const oldRef = ref(storage, existingImagePath);
                await deleteObject(oldRef).catch(() => {});
            }

            // Subir nueva imagen
            const newRef = ref(storage, `misterio/${Date.now()}_${imagen.name}`);
            await uploadBytes(newRef, imagen);
            const imageUrl = await getDownloadURL(newRef);

            // Actualizar Firestore (crea doc si no existe)
            await setDoc(doc(db, "misterio", id), { url: imageUrl }, { merge: true });

            setExistingImageUrl(imageUrl);
            setImagen(null);
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error al actualizar la imagen:", error);
            alert("Error al actualizar la imagen: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container direction="column" alignItems="center" sx={{ maxWidth: 400, margin: "auto", pt: 5 }}>
            {imagen ? (
                <img
                    src={URL.createObjectURL(imagen)}
                    alt="Nueva imagen"
                    style={{ width: "100%", maxHeight: 250, objectFit: "cover", borderRadius: 10, marginBottom: 10 }}
                />
            ) : (
                existingImageUrl && (
                    <img
                        src={existingImageUrl}
                        alt="Imagen actual"
                        style={{ width: "100%", maxHeight: 250, objectFit: "cover", borderRadius: 10, marginBottom: 10 }}
                    />
                )
            )}

            <Button component="label" variant="outlined" fullWidth sx={{ mb: 2 }}>
                {existingImageUrl ? "Cambiar Imagen" : "Cargar Imagen"}
                <input type="file" hidden accept="image/*" onChange={handleImageChange} />
            </Button>

            <Button
                variant="contained"
                color="success"
                fullWidth
                onClick={handleUpload}
                disabled={loading}
            >
                {loading ? <CircularProgress size={24} /> : "Subir Imagen"}
            </Button>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: "100%" }}>
                    Imagen actualizada correctamente
                </Alert>
            </Snackbar>
        </Grid>
    );
};

export default EditarImagenDashboard;
